import { AdminPageLayout } from "@/features/admin/components/AdminPageLayout";
import { FormScreens } from "@/features/developer/form-anatomy/FormScreens";
import { useNav } from "@/utils/nav";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/design/forms/")({
    component: FormScreensPage,
});

function FormScreensPage() {
    useNav([
        { label: "Design", route: { to: "/design" } },
        { label: "Form screens", route: { to: "/design/forms" } },
    ]);

    return (
        <AdminPageLayout
            title="Form screens"
            description="Cover, instructions, question and block. Edit a variable to see it change, or switch it off to hide it."
            maxWidthClassName="max-w-6xl"
        >
            <FormScreens />
        </AdminPageLayout>
    );
}
